// MODULES
import React from "react";

// HELPERS
import {createClassName, getPropertiesByPrefix, parseDraftDataPropsToFieldState, delay} from "@helpers/utils";
import fulfillmentCheck from "./Insured.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import EditableField from "../../../components/EditableField/EditableField";
import Validator from "@classes/Validator";
import FieldsCollection from "../../../../../components/FieldsCollection/FieldsCollection";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";
import countries from "@helpers/countries";
import Select from "../../../../../components/Select/Select";

const countriesOptions = countries.map(({label, code}) => ({label, value: code}));

export default class Insured extends React.PureComponent {
	static companyExclusive = false;
	static privateExclusive = false;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState)
	{
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields)
		{
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}

		if (prevProps.draftData !== props.draftData)
		{
			if (props.draftData)
			{
				// get the draftData props specific to this section only
				const draftDataProps = getPropertiesByPrefix(props.draftData, ["futur_insured_", "checkbox_"]);
				// parse the draftData props into state.fields
				const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);

				this.setState(
					{
						fields: {
							...newFieldsState
						}
					},
					async () =>
					{
						await delay(200);
						onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
					}
				);
			}
		}
	}

	render() {
		const {props, state} = this;
		const {title, session, partner} = props;

		const classes = createClassName("Cob-Fees", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		let selectedCitizenshipIndex = -1;
		for (let i = 0; i < countriesOptions.length; i++) {
			if (state.fields.futur_insured_citizenship === countriesOptions[i].value) {
				selectedCitizenshipIndex = i;
				break;
			}
		}

		let selectedCitizenship2Index = -1;
		for (let i = 0; i < countriesOptions.length; i++) {
			if (state.fields.futur_insured_citizenship_2 === countriesOptions[i].value) {
				selectedCitizenship2Index = i;
				break;
			}
		}

		let citizenshipValue = state.fields.futur_insured_citizenship;
		if (state.fields.checkbox_additional_citizenship.checked) {
			citizenshipValue += "," + state.fields.futur_insured_citizenship_2;
		}

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					{!session.isCompany && (
						<CheckboxWithName
							label="Försäkrad person är samma som Försäkringstagaren"
							name="checkbox_insured_same"
							value={state.fields.checkbox_insured_same.checked ? "yes" : "no"}
							checked={state.fields.checkbox_insured_same.checked}
							onChange={this._onCheckboxChange}
							style={{margin: "10px 0"}}
						/>
					)}

					{(session.isCompany || !state.fields.checkbox_insured_same.checked) && (
						<React.Fragment>
							<h4 style={{margin: "10px 0 10px 2px"}}>Försäkrad person</h4>

							<FieldsCollection
								fieldsPerRow={3}
								fields={[
									{
										render: (
											<EditableField
												name="futur_insured_ssn"
												label="Personnummer"
												value={state.fields.futur_insured_ssn}
												valid={state.validFields.futur_insured_ssn}
												onChange={this._onFieldChange}
												onBlur={this._onFieldBlur}
												disabled={!session.isCompany && state.fields.checkbox_insured_same.checked}
												required={!partner._data.saveDraftButton}
											/>
										),
									},
									{
										render: (
											<EditableField
												name="futur_insured_email"
												label="E-postadress"
												value={state.fields.futur_insured_email}
												valid={state.validFields.futur_insured_email}
												onChange={this._onFieldChange}
												onBlur={this._onFieldBlur}
												disabled={!session.isCompany && state.fields.checkbox_insured_same.checked}
												required={!partner._data.saveDraftButton}
											/>
										),
									}
								]}
							/>

							<h4 style={{margin: "20px 0 10px 2px"}}>Medborgarskap</h4>

							<Select
								name={"futur_insured_citizenship"}
								label="Ange"
								options={countriesOptions}
								selectedIndex={selectedCitizenshipIndex}
								onChange={this._onSelectChange}
								style={{maxWidth: "300px"}}
							/>

							<CheckboxWithName
								label="Ytterligare medborgarskap"
								name="checkbox_additional_citizenship"
								value={state.fields.checkbox_additional_citizenship.checked ? "yes" : "no"}
								checked={state.fields.checkbox_additional_citizenship.checked}
								onChange={this._onCheckboxChange}
								style={{margin: "10px 0"}}
							/>

							{state.fields.checkbox_additional_citizenship.checked && (
								<Select
									name={"futur_insured_citizenship_2"}
									label="Ange"
									options={countriesOptions}
									selectedIndex={selectedCitizenship2Index}
									onChange={this._onSelectChange2}
									style={{maxWidth: "300px"}}
								/>
							)}

              {/* !!! Changed duplicate input name "futur_insured_citizenship" to "futur_insured_citizenships" (plural) !!! */}
							<input type="hidden" name="futur_insured_citizenships" value={citizenshipValue}/>

							<h4 style={{margin: "30px 0 0 0"}}>Fullmakt</h4>

							<CheckboxWithName
								label="Den försäkrade ska vara placeringsberättigad - Fullmakt från försäkringstagaren"
								description="Den försäkrade ska vara placeringsberättigad - Fullmakt från försäkringstagaren"
								name="checkbox_placement_poa"
								value={state.fields.checkbox_placement_poa.checked ? "yes" : "no"}
								checked={state.fields.checkbox_placement_poa.checked}
								onChange={this._onCheckboxChange}
								disabled={!session.isCompany && state.fields.checkbox_insured_same.checked}
								style={{margin: "10px 0"}}
							/>

							<p style={{padding: "20px", fontSize: "12px", background: "#F1F1F1"}}>
								Denna fullmakt utställd av försäkringstagaren gör den försäkrade placeringsberättigad med
								rätt att<br/>
								– Erhålla information om försäkringens villkor och innehav.<br/>
								– Ändra placeringar i försäkringen för befintligt kapital.<br/>
								– Ändra placeringar i försäkringen för eventuell kommande premieinbetalningar.<br/>
								Den placeringsberättigade äger inte rätt att transportera sin behörighet enligt denna
								fullmakt till annan.
								Fullmakten gäller till dess den skriftligen återkallas av försäkringstagaren.
							</p>
						</React.Fragment>
					)}
				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) => {

		if (name === "futur_insured_ssn") {
			return Validator.validateSsn(value);
		}

		if (name === "futur_insured_email") {
			return Validator.validateEmail(value);
		}

		return value.length > 0;
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onSelectChange = (option, index) => {
		CobHelpers.onViewFieldChange.call(this, "futur_insured_citizenship", option.value);
	};

	_onSelectChange2 = (option, index) => {
		CobHelpers.onViewFieldChange.call(this, "futur_insured_citizenship_2", option.value);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};
}

function _getFields() {
	return [
		"checkbox_insured_same",
	];
}

function _getInitialState() {
	if (this.props.prevState) {
		return {...this.props.prevState};
	}

	return {
		validFields: {},
		company: this.props.session.isCompany,
		fields: {
			futur_insured_ssn: "",
			futur_insured_email: "",
			futur_insured_citizenship: "SE",
			futur_insured_citizenship_2: "",
			checkbox_additional_citizenship: {
				checked: false
			},
			checkbox_insured_same: {
				checked: true
			},
			checkbox_placement_poa: {
				checked: false
			}
		}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Insured/Insured.js